import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSelector } from 'react-redux';
import MobileNavigation from './MobileNavigation';
import { useNavigate } from 'react-router-dom';

function Aboutus() {
  const sidebarState = useSelector(state => state.sidebarReducres);
  const navigate = useNavigate();
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);
  return (
    <>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h5>Why Choose Packers Billing?</h5>
                            <p>Pehle Quotation paper par likhna ya computer template par depend rehna bahut mushkil tha. Paper kho gaya toh backup nahi, aur har jagah computer saath nahi hota. Packers Billing aapki inhi problems ka pakka solution hai.</p>

                            <p>
                                Packers Billing – Digital Solution for Movers Content: "India’s most trusted Bilty and Billing software designed specifically for Packers and Movers. Generate professional LR, GST Invoices, and Quotations on the go. Whether you are on a desktop or mobile, manage your entire transport business safely and effortlessly. Start streamlining your moving business today!"
                            </p>

                            <h5 className='mt-3'>Bilty & Quotation On-the-Go:</h5>
                            <p>Ab office mein baithne ki zaroorat nahi! Apne mobile se hi kahin bhi, kabhi bhi professional Bilty (LR), Bills, aur Receipts generate karein.</p>
                            <h5 className='mt-3'>100% Easy to Use:</h5>
                            <p>Isse chalana itna aasaan hai ki aapka helper bhi ise 2 minute mein sikh jayega. No technical knowledge required!</p>
                             <h5 className='mt-3'>Professional Identity:</h5>
                            <p>Jab aap customer ko digital, saaf-suthra bill aur quotation bhejte hain, toh unka trust aap par badh jata hai.</p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <MobileNavigation/>
        </div>
    </>
  )
}

export default Aboutus
